export function mergeRanges(ranges) {
    const result = [];
    ranges.filter(([start, end]) => end > start).sort((a, b) => a[0] - b[0]).forEach(range => {
        const last = result[result.length - 1];
        if (last && range[0] <= last[1] + 0.25) last[1] = Math.max(last[1], range[1]);
        else result.push([...range]);
    });
    return result;
}

export function watchedSegment(previous, time, elapsed, rate = 1) {
    const delta = time - previous;
    return previous !== null && delta > 0 && delta <= Math.max(1, elapsed * rate + 0.5) ? [previous, time] : null;
}
